import React, { useCallback, useMemo, useState } from 'react';

import {
	PopoverSelect,
	PlayerProps,
	Player,
	Switch,
} from '@components';

import {
	PlayerSettings,
	speedSteps,
	SpeedStep,
} from '../default-settings';

import './MeetingPlayer.scss';

interface MeetingPlayerProps extends PlayerProps {
	setNeedScroll: () => void,
	needScroll: boolean,
}

function MeetingPlayer(props: MeetingPlayerProps): JSX.Element {
	const {
		setNeedScroll,
		needScroll,
		playerRef,
		...playerProps
	} = props;

	const
		[playerSpeed, setPlayerSpeed] = useState<number>(PlayerSettings.defaultPlaySpeed),
		[playerLoaded, setPlayerLoaded] = useState<boolean>(false);

	const onChangePlaySpeed = useCallback((newSpeedStep: SpeedStep): void => {
		setPlayerSpeed(newSpeedStep.value);
		playerRef.current.playbackRate = newSpeedStep.value;
	}, [playerRef]);

	const currentSpeedStep = useMemo((): SpeedStep => {
		return {
			value: playerSpeed,
			name: `${playerSpeed}x`,
		};
	}, [playerSpeed]);

	// ––:–– / ––:––

	return (
		<div className="meeting-player">
			<Player
				playerRef={playerRef}
				onPlayerLoaded={() => setPlayerLoaded(true)}
				{...playerProps}
			/>
			<PopoverSelect<SpeedStep>
				disabled={!playerLoaded}
				onChange={onChangePlaySpeed}
				className="meeting-player__speed"
				value={currentSpeedStep}
				options={speedSteps}
				textName="name"
			/>
			<Switch
				disabled={!playerLoaded}
				titleDisable="Автоскролл выключен"
				titleEnable="Автоскролл включен"
				className="meeting-player__switch"
				onChange={setNeedScroll}
				value={needScroll}
			/>
		</div>
	);
}

export {MeetingPlayer};